import { Component, OnInit } from '@angular/core';
import { AuthService, JwtPayload } from '../auth.service';
import { timer } from 'rxjs';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit{

  verified: boolean = false;
  emailSent: boolean = false;
  emailCooldown: number = 60;
  hashedEmail: { email: string }

  constructor(private authService: AuthService, private utilService: UtilitieService){}


  async resendEmailVerification(){
    let result = await this.authService.emailVerificationRequest();
    if(result){
      this.emailSent = true;
      this.authService.openSnackBar('Verification email has been sent','');
      const counter = timer(1000, 1000);
      const sub = counter.subscribe(tickValue =>{
        this.emailCooldown -= tickValue;
        if(tickValue === 60){
          this.emailSent = false;
          this.emailCooldown = 60;
          sub.unsubscribe();
        }
      });
    
      return;
    }
    this.authService.openSnackBar('There was an issue sending verification email','Please try again later');
  }
  async checkStatus(){
      const response = await this.authService.checkAccountStatus();
      const jwt: JwtPayload = this.authService.decodeToken(response.token);
      this.verified = jwt.verified;
      if(jwt.verified){
        this.authService.storeAuthToken(response);
      }
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.hashedEmail = await this.authService.getUserHashedEmail();
    this.checkStatus();
    this.utilService.updateLoading(false);
  }

}
